import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { ADDRESS, EMAIL, PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT } from "@/lib/site";

const HOLIDAY_LINKS = [
  { label: "International Holidays", to: "/international-holidays" },
  { label: "India Holidays", to: "/india-holidays" },
  { label: "Honeymoon", to: "/honeymoon" },
  { label: "Family Holidays", to: "/family-holidays" },
  { label: "Group Tours", to: "/group-tours" },
  { label: "Visa Assistance", to: "/visa" },
  { label: "Flights & Hotels", to: "/flights-hotels" },
];

const COMPANY_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Why Choose Us", to: "/about" },
  { label: "Contact Us", to: "/contact" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Cancellation Policy", to: "/cancellation-policy" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navydeep text-slate-300 pt-16 pb-8 mt-0 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="inline-block">
              <span className="inline-block bg-white rounded-xl px-4 py-3">
                <img src="/logo-header.png" alt="D Travel Link — Linking Dreams to Destinations" className="h-14 w-auto" />
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              A Thane-based travel agency crafting tailor-made holidays, honeymoons, group tours and visa assistance — from first idea to safe return.
            </p>
            <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-button"
               className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#1fb857] transition-colors">
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm tracking-[0.15em] uppercase">Holidays</h4>
            <ul className="mt-4 space-y-2.5">
              {HOLIDAY_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-slate-400 hover:text-sky-300 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm tracking-[0.15em] uppercase">Company</h4>
            <ul className="mt-4 space-y-2.5">
              {COMPANY_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-slate-400 hover:text-sky-300 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm tracking-[0.15em] uppercase">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-2.5 text-slate-300 hover:text-sky-300 transition-colors">
                  <Phone className="w-4 h-4 text-sky-400 shrink-0" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-2.5 text-slate-300 hover:text-sky-300 transition-colors">
                  <Mail className="w-4 h-4 text-sky-400 shrink-0" /> {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-slate-400">
                <MapPin className="w-4 h-4 text-sky-400 shrink-0 mt-0.5" />
                <span data-testid="footer-address-text">{ADDRESS}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} D Travel Link, Thane West, Maharashtra. All rights reserved.</p>
          <div className="flex items-center gap-5 text-xs text-slate-500">
            <Link to="/terms-and-conditions" className="hover:text-sky-300 transition-colors">Terms</Link>
            <Link to="/privacy-policy" className="hover:text-sky-300 transition-colors">Privacy</Link>
            <Link to="/cancellation-policy" className="hover:text-sky-300 transition-colors">Cancellation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
